// Constants.
import * as PayConnectedPackagesConstants from 'constants/PayConnectedPackagesConstants';
import * as AuthConstants from 'constants/AuthConstants';
import * as ErrorConstants from 'constants/ErrorConstants';
import {LOAD_PAYMENT_METHODS_REQUEST} from "constants/PayConnectedPackagesConstants";

const initialState = {
  isFetching: false,
  isFetched: false,
  payConnectedPackages: {},
  paymentMethods: [],
  errorMessage: '',
};

export default function products(state = initialState, action = {}) {
  switch (action.type) {
    case PayConnectedPackagesConstants.LOAD_PAY_CONNECTED_PACKAGES_REQUEST:
      return {
        ...state,
        isFetching: true,
        isFetched: false,
      };
    case PayConnectedPackagesConstants.LOAD_PAYMENT_METHODS_REQUEST:
      return {
        ...state,
        isFetching: true,
        isFetched: false,
      };
    case PayConnectedPackagesConstants.LOAD_PAY_CONNECTED_PACKAGES_SUCCESS:
      return {
        ...state,
        isFetching: false,
        isFetched: true,
        payConnectedPackages: action.payConnectedPackages,
      };
    case PayConnectedPackagesConstants.LOAD_PAYMENT_METHODS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        isFetched: true,
        paymentMethods: action.payload.paymentMethods,
        payConnectedPackages: action.payload.paymentMethods,
      };
    case PayConnectedPackagesConstants.LOAD_PAY_CONNECTED_PACKAGES_FAILURE:
      return {
        ...state,
        isFetching: false,
        isFetched: false,
        payConnectedPackages: {},
      };
    case AuthConstants.LOGOUT_SUCCESS:
    case AuthConstants.LOGOUT_TOKEN_SUCCESS:
    case ErrorConstants.LOAD_REQUEST_FAILURE:
      return {
        ...state,
        isFetching: false,
        isFetched: false,
        payConnectedPackages: {},
        errorMessage: '',
      };
    default:
      return state;
  }
}
